module.exports = __webpack_public_path__ + "img/mana.268e4efb.png";